import { render, staticRenderFns } from "./QuejasClinica.vue?vue&type=template&id=4b76c68a&scoped=true"
import script from "./QuejasClinica.vue?vue&type=script&lang=js"
export * from "./QuejasClinica.vue?vue&type=script&lang=js"
import style0 from "./QuejasClinica.vue?vue&type=style&index=0&id=4b76c68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b76c68a",
  null
  
)

export default component.exports